import type { ReactNode } from 'react';
import { CenoxWordmark } from '../../components/platform/CenoxMark';

/**
 * Shared frame for sign-in and registration.
 *
 * Branded CenoX, not CenoX Business, and the distinction is the whole reason
 * this file changed. One account reaches eight products; signing in is a
 * platform act. Putting a product's name on the door told everyone arriving
 * at cenox.ai that the platform *was* that product — including the people
 * buying Automation or Robotics, who would have had to look past a shop's
 * name to find theirs.
 *
 * There is no second account system behind this. The credentials, the session,
 * the rotation and the memberships are exactly what they were; only the sign
 * above the door changed.
 *
 * Single-column and centred at every width — these screens are reached far
 * more often on a phone than a desktop, and a split hero layout would just
 * push the form below the fold.
 */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}): ReactNode {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-slate-50 px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-6 flex items-center justify-center">
          <CenoxWordmark />
        </div>

        <div className="card p-6 sm:p-8">
          <div className="mb-6 text-center">
            <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
          </div>
          {children}
        </div>

        {footer && <p className="mt-5 text-center text-sm text-slate-600">{footer}</p>}
      </div>
    </div>
  );
}
